module.exports = __webpack_public_path__ + "img/ring_y_skip_1_1.2cfee2c3.png";